import * as React from 'react';
import {
  useMap,
} from 'react-leaflet';

import './style.scss';
import { LatLngExpression } from 'leaflet';
import { useTranslation } from 'react-i18next';
import { MAP_ZOOM } from '../../config/constants';

type Props = {
  center: LatLngExpression
};

const LeafletCenterControl = (props: Props) => {
  const { center } = props;
  const map = useMap();
  const { t } = useTranslation();

  return (
    <button
      className="CenterControl icon-before icon-house icon-variant-black"
      type="button"
      onClick={() => {
        map.flyTo(center, MAP_ZOOM.DEFAULT);
      }}
    >
      {t('container_locations.buttons.center')}
    </button>
  );
};

export default LeafletCenterControl;
